module.exports = "//public.getcloudapp.com/packs/media/images/icons-premium-star-bd92ee08fe1fcd33af9f515e0e58cf2c.svg";